<template>
    <main>
        <div class="common-report customer-turnover-view">
            <customer-turnover-relation></customer-turnover-relation>
            <customer-turnover-allocation></customer-turnover-allocation>
        </div>
    </main>
</template>

<script>
    const CustomerTurnoverRelation = () =>
        import("./customer-turnover/CustomerTurnoverRelation");
    const CustomerTurnoverAllocation = () =>
        import("./customer-turnover/CustomerTurnoverAllocation");
    import _ from 'lodash';

    export default {
        name: "CustomerTurnover",
        components: {CustomerTurnoverAllocation, CustomerTurnoverRelation},
        computed: {
            filter: function () {
                return this.$store.state.reports.customerTurnoverFilter;
            }
        },
        beforeMount() {
            this.requestApi();
        },
        methods: {
            requestApi: function () {
                // set the row count to initial value
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                // fetch the forecast data
                this.$store.dispatch("fetchCustomerTurnoverReport", filter);
                this.$store.dispatch("fetchReportAggregates",filter);
            }
        }
    };
</script>

<style scoped>
</style>